import React from "react";

const InnerBanner = ({ name }) => {
  return (
    <div className="inner_banner">
      <div className="flex-center bg-creame bg-gray">
        <h1 className="roboto">{name}</h1>
      </div>
    </div>
  );
};

export default InnerBanner;
